
import { MarineTrafficData } from '../types';

// NOTE: This is a simulation service. 
// In a production environment, this would call the MarineTraffic API directly.
// e.g. https://api.marinetraffic.com/v05/vesselPositions?vesselID=...&protocol=json

export const fetchVesselData = async (vesselName: string): Promise<MarineTrafficData | null> => {
  // Simulate network latency
  await new Promise(resolve => setTimeout(resolve, 2000));

  if (!vesselName) return null;

  // Mock data generator based on vessel name to keep results consistent for demo
  const isMoving = vesselName.length % 2 === 0;
  const seed = vesselName.length;
  
  // Generating coordinates roughly around East Africa / Indian Ocean
  const baseLat = -6.8; // Dar es Salaamish
  const baseLon = 39.3; 
  
  const latOffset = (Math.random() * 10) - 5;
  const lonOffset = (Math.random() * 10);

  return {
    vesselName: vesselName,
    imo: `9${Math.floor(100000 + Math.random() * 900000)}`,
    latitude: baseLat + latOffset,
    longitude: baseLon + lonOffset,
    speed: isMoving ? 12 + Math.random() * 5 : 0.5,
    course: 180 + Math.random() * 40, // Heading south roughly
    status: isMoving ? "Underway Using Engine" : "At Anchor",
    lastUpdated: new Date().toISOString(),
    nextPort: "DAR ES SALAAM",
    eta: getFutureDate(2)
  };
};

const getFutureDate = (daysToAdd: number) => {
  const date = new Date();
  date.setDate(date.getDate() + daysToAdd);
  return date.toISOString().replace('T', ' ').substring(0, 16) + ' UTC';
};
